import { ReactNode } from 'react';

import {
  HexIcon,
  Icons,
  withProps,
  Typography,
  Stack,
} from '@cast/design-system';

type DialogFeedbackMessageProps = {
  variant: 'success' | 'error';
  title: ReactNode;
  subTitle?: ReactNode;
  body?: ReactNode;
  testId?: string;
};

const SuccessIcon = withProps(HexIcon, {
  variant: 'success' as const,
  icon: <Icons.Check />,
});
const ErrorIcon = withProps(HexIcon, { variant: 'error' as const });

export const DialogFeedbackMessage = ({
  variant,
  title,
  subTitle,
  body,
  testId,
}: DialogFeedbackMessageProps) => {
  const Icon = variant === 'success' ? SuccessIcon : ErrorIcon;

  return (
    <Stack
      display="grid"
      gridTemplateColumns="36px auto"
      gap={8}
      data-testid={testId}
    >
      <Icon size={36} />
      <Stack>
        <Typography variant="h5" mt={4} mb={6}>
          {title}
        </Typography>
        {subTitle && (
          <Typography variant="P12B" mb={16}>
            {subTitle}
          </Typography>
        )}
        {body && (
          <Typography variant="P12R" color="textSecondary">
            {body}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
